export function getSorting(order, orderBy) {
  return order === 'desc'
    ? (a, b) => (b[orderBy]=== null || b[orderBy].length === 0 || b[orderBy].toLowerCase() < a[orderBy].toLowerCase() ? -1 : 1)
    : (a, b) => (a[orderBy]=== null || a[orderBy].length === 0 || a[orderBy].toLowerCase() < b[orderBy].toLowerCase() ? -1 : 1);
}

export function getNumberSorting(order, orderBy) {
  return order === 'desc'
    ? (a, b) => (b[orderBy]=== null || b[orderBy].length === 0 || parseInt(b[orderBy],10) < parseInt(a[orderBy],10) ? -1 : 1)
    : (a, b) => (a[orderBy]=== null || a[orderBy].length === 0 || parseInt(a[orderBy],10) < parseInt(b[orderBy],10) ? -1 : 1);
}

export function getFloatSorting(order, orderBy) {
  return order === 'desc'
    ? (a, b) => (b[orderBy]=== null || b[orderBy].length === 0 || parseFloat(b[orderBy]) < parseFloat(a[orderBy]) ? -1 : 1)
    : (a, b) => (a[orderBy]=== null || a[orderBy].length === 0 || parseFloat(a[orderBy]) < parseFloat(b[orderBy]) ? -1 : 1);
}

export function getBooleanSorting(order, orderBy) {
  return order === 'desc'
    ? (a, b) => (b[orderBy] ? 1 : -1)
    : (a, b) => (a[orderBy] ? 1 : -1);
}

